
class GlobalService {
    oauth = null;

    getOAuthToken = () => {
        return this.oauth;
    };

    setOAuthToken = (oauthPayload) => {
        if(this.oauth){
            this.oauth = Object.assign(this.oauth, oauthPayload);
        }else{
            this.oauth = oauthPayload;
        }
        
    };

}
// eslint-disable-next-line
export default new GlobalService();